import { EquipmentStatusCategoryOptions } from '@models/EquipmentStatus.model';

const getStatusColor = (category: EquipmentStatusCategoryOptions) => {
  if (category === 'Online') return '#249D0E';
  if (category === 'Offline') return '#DFAE00';
  return '#838A91';
};

export { getStatusColor };
